import script from "./RecipeStats.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecipeStats.vue?vue&type=script&setup=true&lang=ts"

import "./RecipeStats.vue?vue&type=style&index=0&id=1e5eeb41&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e5eeb41"]])

export default __exports__